const isDecimal = (number) => {
  return Math.round(number) !== number;
};

const isNumber = (number) => {
  // eslint-disable-next-line
  // == on purpose
  return number == parseFloat(number);
};

export const toFixed = (number, digits = 2) => {
  if (!isNumber(number)) return number;

  const parsedNumber = parseFloat(number);
  if (!isDecimal(parsedNumber)) return parsedNumber;

  return parsedNumber.toFixed(digits);
};
